import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  canonicalUrl?: string;
  robots?: string;
}

export default function SEO({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  canonicalUrl,
  robots,
}: SEOProps) {
  const siteUrl = "https://autochain.com.hk";
  // 使用 512x512 的 Android Chrome 圖片作為默認 OG 圖片（社交媒體分享）
  const defaultImage = `${siteUrl}/android-chrome-512x512.png`;
  const resolvedOgImage = ogImage || defaultImage;
  const ogImageWidth = ogImage ? "1200" : "512";
  const ogImageHeight = ogImage ? "630" : "512";

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonicalUrl && (
        <link rel="canonical" href={`${siteUrl}${canonicalUrl}`} />
      )}

      {/* New Favicon Configuration - 使用絕對URL和版本參數強制更新 */}
      <link
        rel="icon"
        type="image/png"
        href={`${siteUrl}/favicon-96x96.png?v=2025102001`}
        sizes="96x96"
      />
      <link
        rel="icon"
        type="image/svg+xml"
        href={`${siteUrl}/favicon.svg?v=2025102001`}
      />
      <link rel="shortcut icon" href={`${siteUrl}/favicon.ico?v=2025102001`} />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${siteUrl}/apple-touch-icon.png?v=2025102001`}
      />

      {/* Open Graph Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={resolvedOgImage} />
      <meta property="og:image:secure_url" content={resolvedOgImage} />
      <meta property="og:image:width" content={ogImageWidth} />
      <meta property="og:image:height" content={ogImageHeight} />
      {canonicalUrl && (
        <meta property="og:url" content={`${siteUrl}${canonicalUrl}`} />
      )}
      <meta property="og:site_name" content="AUTOCHAIN" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={resolvedOgImage} />

      {/* Additional Meta Tags */}
      <meta name="robots" content={robots ?? "index, follow"} />
      <meta name="language" content="zh-HK" />
      <meta name="author" content="AUTOCHAIN TECHNOLOGY" />
    </Helmet>
  );
}
